<!--
 * @Author: DESKTOP-MBAI5QL\zwzh 2356226565@qq.com
 * @Date: 2024-05-08 11:33:03
 * @LastEditors: DESKTOP-MBAI5QL\zwzh 2356226565@qq.com
 * @LastEditTime: 2024-05-10 16:56:03
 * @FilePath: \roses-admin-vue\src\views\pages\register\register-layout\RegisterLayout.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="registerLayout">
    <el-container class="layout">
      <el-header :style="{ height: $route.path === '/register/systemselect' ? '64px' : '128px' }">
        <RegisterHeader />
      </el-header>
      <el-main>
        <router-view style="background-color: #fff; min-height: 100%" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import RegisterHeader from './RegisterHeader';

export default {
  components: {
    RegisterHeader
  },
  computed: {},
  created() {
    // console.log(this.$route.path);
  }
};
</script>

<style lang="less" scoped>
.registerLayout {
  // position: relative;
  background: url('~assets/images/bg.png') no-repeat;
  background-size: cover;
  // background-color: #f3f6fe;
}
.layout {
  // position: absolute;
  // left: 0%;
  // top: 0%;
  // transform: translateX(0%);
  // width: 70%;
  // height: 763px;
  // min-width: 900px;
  //height: 690px;
  //min-height: 70%;
  // box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
}
.el-header {
  padding: 0;
}
.el-main {
  overflow: hidden;
  padding: 0;
  // background-color: #fff;
}
.el-main :first-child {
  background-color: transparent !important;
}
/deep/.el-input__inner {
  border-radius: 0;
}
</style>
